import { Component } from '@angular/core';

@Component({
  selector: 'app-hrms-link',
  templateUrl: './hrms-link.component.html',
  styleUrls: ['./hrms-link.component.scss']
})
export class HrmsLinkComponent {

}
